<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2x"><a id="page_viii"></a><a id="page_ix"></a><span class="big">C</span><span class="space">Contents</span></h2>
<p class="toc"><a href="#/xhtml/preface01#pre1">Preface to the Second Edition</a></p>
<p class="toc"><a href="#/xhtml/preface02#pre2">Preface to the First Edition</a></p>
<p class="toc"><a href="#/xhtml/acknowledgments#ack">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/abbreviations#abb">List of Abbreviations</a></p>
<p class="toc1"><a href="#/xhtml/chapter01#ch1"><strong>1<span class="space1">Introduction: An Ocean in Kansas?</span></strong></a></p>
<p class="toc1"><a href="#/xhtml/chapter02#ch2"><strong>2<span class="space1">Our Discovery of the Western Interior Sea</span></strong></a></p>
<p class="toc1"><a href="#/xhtml/chapter03#ch3"><strong>3<span class="space1">Invertebrates, Plants, and Trace Fossils</span></strong></a></p>
<p class="toc1"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample"><strong>4<span class="space1">Sharks: Sharp Teeth and Shell Crushers</span></strong></span></p>
<p class="toc1"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample"><strong>5<span class="space1">Fishes, Large and Small</span></strong></span></p>
<p class="toc1"><span href="#/xhtml/chapter06#ch6" title="Link target outside of Sample"><strong>6<span class="space1">Turtles: Leatherback Giants</span></strong></span></p>
<p class="toc1"><span href="#/xhtml/chapter07#ch7" title="Link target outside of Sample"><strong>7<span class="space1">Where the Elasmosaurs Roamed</span></strong></span></p>
<p class="toc1"><span href="#/xhtml/chapter08#ch8" title="Link target outside of Sample"><strong>8<span class="space1">Pliosaurs and Polycotylids</span></strong></span></p>
<p class="toc1"><span href="#/xhtml/chapter09#ch9" title="Link target outside of Sample"><strong>9<span class="space1">Enter the Mosasaurs</span></strong></span></p>
<p class="toc2"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample"><strong>10<span class="space2">Pteranodons: Rulers of the Air</span></strong></span></p>
<p class="toc2"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample"><strong>11<span class="space2">Feathers and Teeth</span></strong></span></p>
<p class="toc2"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample"><strong>12<span class="space2">Dinosaurs?</span></strong></span></p>
<p class="toc2"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample"><strong>13<span class="space2">The Big Picture</span></strong></span></p>
<p class="toc"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue: Where Did It Go?</span></p>
<p class="toc"><span href="#/xhtml/references#ref" title="Link target outside of Sample">References</span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?86f510c0